import React from 'react';
import './PortfolioSection.css'; // Ensure this path is correct

// Import images
import LogoDesign from '../assets/imgs/logo-design-portfolio-1.png';
import Others from '../assets/imgs/Others.jpg';
import CustomBranding from '../assets/imgs/custom-branding.jpg';
import SocialMediaKit from '../assets/imgs/Social media kit .jpg';
import StationaryDesign from '../assets/imgs/Stationary Design .jpg';
import WebsiteDesign from '../assets/imgs/webchange.jpeg';
import '../App.css'


const PortfolioSection = () => {
    return (
        <section className="container mt-5">
            <div className="row">
                <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 text-center p-4 ">
                    <h1>My Portfolio</h1>
                </div>

                {/* First Column: 2 Images */}
                <div className="col-lg-3 col-md-6 col-sm-12 mb-4">
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <img src={LogoDesign} className="card-img-top-2" alt="Image 1" />
                                <div className="overlay-text"><a href="portfolio.html" className="link-text">Logo Design</a></div>
                            </div>
                        </div>
                        <div className="col-12 mt-4">
                            <div className="card">
                                <img src={Others} className="card-img-top-2" alt="Image 2" />
                                <div className="overlay-text"><a href="portfolio.html" className="link-text">Others</a></div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Second Column: 1 Image */}
                <div className="col-lg-3 col-md-6 col-sm-12 mb-4">
                    <div className="card">
                        <img src={CustomBranding} className="card-img-top" alt="Image 3" />
                        <div className="overlay-text"><a href="portfolio.html"className="link-text" >Custom Branding</a></div>
                    </div>
                </div>

                {/* Third Column: 2 Images */}
                <div className="col-lg-3 col-md-6 col-sm-12 mb-4">
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <img src={SocialMediaKit} className="card-img-top-2" alt="Image 4" />
                                <div className="overlay-text"><a href="portfolio.html" className="link-text">Social Media Kit</a></div>
                            </div>
                        </div>
                        <div className="col-12 mt-4">
                            <div className="card">
                                <img src={StationaryDesign} className="card-img-top-2" alt="Image 5" />
                                <div className="overlay-text"><a href="portfolio.html" className="link-text">Stationary Design</a></div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Fourth Column: 1 Image */}
                <div className="col-lg-3 col-md-6 col-sm-12 mb-4">
                    <div className="card">
                        <img src={WebsiteDesign} className="card-img-top" alt="Image 6" id="control-h" />
                        <div className="overlay-text"><a href="portfolio.html" className="link-text">Website Design</a></div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default PortfolioSection;
